import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
import NotificationAlert from 'componentes/generic/Notification.js';
const URI = ApiEndpoint + 'administration/';
const URIConfig = ApiEndpoint + 'configuration/';

const EditCustomer = ({ idCustomer, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [status, setStatus] = useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();
  const [customer, setCustomer] = useState({
    clave: '',
    razonsocial: '',
    rfc: '',
    esmoral: 'true',
    determinante: '',
    saldo: '0',
    proveedor: '',
    idstatus: '1'
  });

  const getStatusList = async () => {
    httpClient('GET', URIConfig + 'statusbytype/4', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStatus(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getCustomer = async () => {
    setCustomer(null);

    httpClient('GET', URI + 'customers/' + idCustomer, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setValue('clave', response.data.clave);
          setValue('razonsocial', response.data.razonsocial);
          setValue('rfc', response.data.rfc);
          setValue('esmoral', response.data.esmoral);
          setValue('determinante', response.data.determinante);
          setValue('saldo', response.data.saldo);
          setValue('proveedor', response.data.proveedor);
          setValue('idstatus', response.data.idstatus);
          setSelectedStatus(response.data.idstatus);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (idCustomer > 0) getCustomer();
    getStatusList();
  }, []);

  const onSubmit = data => {
    console.log(data);

    if (idCustomer > 0) {
      httpClient(
        'put',
        URI + 'customers/' + idCustomer,
        {
          clave: data.clave,
          razonsocial: data.razonsocial,
          rfc: data.rfc,
          esmoral: data.esmoral,
          determinante: data.determinante,
          saldo: data.saldo,
          proveedor: data.proveedor,
          idstatus: data.idstatus
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'customers',
        {
          clave: data.clave,
          razonsocial: data.razonsocial,
          rfc: data.rfc,
          esmoral: data.esmoral,
          determinante: data.determinante,
          saldo: data.saldo,
          proveedor: data.proveedor,
          idstatus: data.idstatus
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>Clave</Form.Label>
                  <FormControl
                    {...register('clave', {
                      required: 'Campo Requerido',
                      minLength: {
                        value: 2,
                        message: 'La Clave debe tener al menos 4 caracteres'
                      },
                      maxLength: {
                        value: 4,
                        message: 'La Clave debe tener maximo 4 caracteres'
                      }
                    })}
                    type="text"
                    defaultValue={customer?.clave}
                    isInvalid={!!errors.clave}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.clave?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col className="mb-8"></Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Razon Social</Form.Label>
                  <FormControl
                    {...register('razonsocial', {
                      required: 'Campo Requerido'
                    })}
                    type="text"
                    defaultValue={customer?.razonsocial}
                    isInvalid={!!errors.razonsocial}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.razonsocial?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>RFC</Form.Label>
                  <FormControl
                    style={{ textTransform: 'uppercase' }}
                    onInput={e => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                    onBlur={e => {
                      const cleanRFC = e.target.value
                        .replace(/-/g, '')
                        .toUpperCase();
                      setValue('rfc', cleanRFC, { shouldValidate: true });
                    }}
                    {...register('rfc', {
                      required: 'Campo Requerido',
                      pattern: {
                        value:
                          /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
                        message: 'RFC inválido, Formato RFC: AAA(F)-000101-AA1'
                      }
                    })}
                    type="text"
                    defaultValue={customer?.rfc}
                    isInvalid={!!errors.rfc}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.rfc?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Check // prettier-ignore
                    type="checkbox"
                    id={`esmoral`}
                    {...register('esmoral')}
                    label={`Persona Moral`}
                    name="esmoral"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Determinante</Form.Label>
                  <FormControl
                    {...register('determinante', {
                      required: 'Campo Requerido',
                      pattern: {
                        value: /^\d{1,5}$/,
                        message: 'La Clave debe tener menos a cuatro caracteres'
                      }
                    })}
                    type="number"
                    defaultValue={customer?.determinante}
                    isInvalid={!!errors.determinante}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.determinante?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Saldo</Form.Label>
                  <FormControl
                    {...register('saldo', {
                      required: 'Campo Requerido'
                    })}
                    type="number"
                    defaultValue={customer?.saldo}
                    isInvalid={!!errors.saldo}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.saldo?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Proveedor</Form.Label>
                  <FormControl
                    {...register('proveedor', {
                      required: 'Campo Requerido',
                      maxLength: {
                        value: 10,
                        message: 'El proveedor debe tener maximo 10 caracteres'
                      }
                    })}
                    type="text"
                    defaultValue={customer?.proveedor}
                    isInvalid={!!errors.proveedor}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.proveedor?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Status</Form.Label>
                  <select
                    aria-label="Default select"
                    name="idstatus"
                    id="idstatus"
                    className="form-control"
                    {...register('idstatus', {
                      required: 'Campo Requerido'
                    })}
                    onChange={e => {
                      setValue('idstatus', e.target.value, {
                        shouldValidate: true
                      });
                      setSelectedStatus(e.target.value);
                    }}
                    value={`${selectedStatus}`}
                    style={{ minWidth: '250px' }}
                  >
                    <option key={'location_0'} value="">
                      Selecciona un status
                    </option>
                    {!!status?.length &&
                      status.map(estado => (
                        <option key={estado.idstatus} value={estado.idstatus}>
                          {estado.descripcion}
                        </option>
                      ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    {errors.idstatus?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
      />
    </>
  );
};
EditCustomer.propTypes = {
  idCustomer: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired
};
export default EditCustomer;
